import triggerQualtrics from '../../../../helpers/triggerQualtrics';
import { clearCasesState } from '../../../../redux/cases/cases.slice';
import { previousStepUpdated, questionnaireCleared, stepUpdated } from '../../../../redux/questionnaire/questionnaire.slice';
import { QuestionnaireFlow } from '../../../../redux/questionnaire/typings';
import { clearUiState, closeModal } from '../../../../redux/ui/ui.slice';
import { ModalType } from '../../../../redux/ui/typings';
import { clearUserAnswers } from '../../../../redux/userAnswers/userAnswers.slice';
import { triggerAnalyticsEvent } from 'syf-js-utilities';
import { Analytics } from '../../../../helpers/analyticsMiddleware';
export var closeQuestionnaireModal = function (flow) {
    return function (dispatch, getState) {
        var _a = getState(), returnToParent = _a.appConfig.returnToParent, step = _a.questionnaire.step;
        if (step === QuestionnaireFlow.End) {
            triggerQualtrics(step);
        }
        returnToParent(flow);
        dispatch(clearUserAnswers());
        dispatch(questionnaireCleared());
        dispatch(clearCasesState());
        dispatch(clearUiState());
    };
};
export var closeModalHelper = function (flow) {
    return function (dispatch, getState) {
        var _a = getState(), _b = _a.questionnaire, step = _b.step, isRedispute = _b.isRedispute, ui = _a.ui;
        var previousQuestionnaireStep = step === QuestionnaireFlow.InProgress || step === QuestionnaireFlow.Review;
        if ((ui === null || ui === void 0 ? void 0 : ui.modalType) === ModalType.FAQs) {
            return dispatch(closeModal());
        }
        if (previousQuestionnaireStep) {
            dispatch(previousStepUpdated(step));
            return dispatch(stepUpdated(QuestionnaireFlow.CancelQuestionnaire));
        }
        if (isRedispute) {
            triggerAnalyticsEvent({
                PageKind: Analytics.Activity,
                PageFunction: Analytics.DisputeTransaction,
                pageName: Analytics.View
            });
            if (step === QuestionnaireFlow.APIError) {
                return dispatch(closeQuestionnaireModal(flow));
            }
        }
        else {
            triggerAnalyticsEvent({
                PageFunction: 'disputes'
            });
        }
        if (step === QuestionnaireFlow.APIError) {
            return dispatch(closeModal());
        }
        triggerQualtrics(step);
        return dispatch(closeQuestionnaireModal(flow));
    };
};
//# sourceMappingURL=closeHandlers.js.map